'use strict';
angular.module('manageSysXhsgCreateNewCircuitConfigModule', [])
    .controller('manageSysXhsgCreateNewCircuitConfigCtrl', ['$scope', 'trsHttpService', '$q', '$modalInstance', 'trsHttpService', '$filter', '$validation', 'modalDialog', 'curItem', 'trsspliceString', '$state', 'TenantConfig',
        function($scope, $trsHttpService, $q, $modalInstance, trsHttpService, $filter, $validation, modalDialog, curItem, trsspliceString, $state, TenantConfig) {
            initStatus();
            initData();

            /**
             * [initStatus 初始化状态]
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    authorName: '',
                    STARTTIME: '',
                    ENDTIME: '',
                    keyword: '',
                    authorStatus: '1',
                    noSelected: false,
                    isNew: angular.isDefined(curItem) ? false : true,
                    TenantConfig: angular.isDefined(TenantConfig) ? true : false,
                };
                $scope.data = {
                    xhsgLineData: [],
                    selectedArray: [],
                    tempSelectedArray: [],
                    selectedTempSelectedArray: [],
                };
            }

            /**
             * [initData 初始化数据]
             * @return {[type]} [description]
             */
            function initData() {
                getXHSGLineConfig().then(function() {
                    if (!$scope.status.isNew) getConfigWithId();
                });
            }

            /**
             * [getConfigWithId 获取线路配置信息]
             * @return {[type]} [description]
             */
            function getConfigWithId() {
                var params = {
                    serviceid: 'mlf_xinhuashe',
                    methodname: 'findXHSLineAuthor',
                    ObjectId: curItem.XHSLINEAUTHORID
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    $scope.status.authorName = data.AUTHORNAME;
                    $scope.status.authorStatus = data.AUTHORSTATUS;
                    $scope.status.STARTTIME = data.STARTTIME;
                    $scope.status.ENDTIME = data.ENDTIME;
                    $scope.data.selectedArray = dataCecall(data.LINEIDS);
                });
            }

            /**
             * [dataCecall 匹配选中线路]
             * @param  {[type]} idsString [description]
             * @return {[type]}           [description]
             */
            function dataCecall(idsString) {
                var ids = idsString.split(',');
                var result = [];
                for (var i = 0; i < ids.length; i++) {
                    result = result.concat($scope.data.xhsgLineData.filter(function(obj, index) {
                        return obj.ID == ids[i];
                    }));
                }
                return result;
            }

            /**
             * [querySearchByKeyword 关键词快速检索]
             * @param  {[type]} e [description]
             * @return {[type]}   [description]
             */
            $scope.querySearchByKeyword = function(e) {
                if (e.keyCode == 13 || angular.isUndefined(e.keyCode)) getXHSGLineConfig();
            };

            /**
             * [toggleStatus 更换状态]
             * @return {[type]} [description]
             */
            $scope.toggleStatus = function() {
                $scope.status.authorStatus = $scope.status.authorStatus == '1' ? '0' : '1';
            };

            /**
             * [getXHSGLineConfig 查询新华社线路列表]
             * @return {[type]} [description]
             */
            function getXHSGLineConfig() {
                var defer = $q.defer();
                var params = {
                    serviceid: 'mlf_xinhuashe',
                    methodname: 'querryXHSLine',
                    // Keyword: $scope.status.keyword,
                };
                $scope.status.keyword == '' ? delete params.Keyword : params.Keyword = $scope.status.keyword;
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    $scope.data.xhsgLineData = data.CONTENT;
                    $scope.data.tempSelectedArray = [];
                    $scope.data.selectedTempSelectedArray = [];
                    defer.resolve();
                });
                return defer.promise;
            }

            /**
             * [selected2List 右侧选中线路]
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.selected2List = function(item) {
                var n = $scope.data.selectedTempSelectedArray.indexOf(item);
                n > -1 ? $scope.data.selectedTempSelectedArray.splice(n, 1) : $scope.data.selectedTempSelectedArray.push(item);
            };

            /**
             * [selected2ListFun 从已选列表移除]
             * @return {[type]} [description]
             */
            $scope.selected2ListFun = function() {
                var n;
                for (var i = 0; i < $scope.data.selectedTempSelectedArray.length; i++) {
                    n = $scope.data.selectedArray.indexOf($scope.data.selectedTempSelectedArray[i]);
                    $scope.data.selectedArray.splice(n, 1);
                }
                $scope.data.selectedTempSelectedArray = [];
            };

            $scope.clearSelected = function() {
                modalDialog.alertType('确定清空已选线路？', '', 'ask', true, function() {
                    $scope.data.selectedTempSelectedArray = [];
                    $scope.data.selectedArray = [];
                }, function() {});
            };

            /**
             * [list2Selected 左侧线路选中]
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.list2Selected = function(item) {
                var n = $scope.data.tempSelectedArray.indexOf(item);
                n > -1 ? $scope.data.tempSelectedArray.splice(n, 1) : $scope.data.tempSelectedArray.push(item);
            };

            /**
             * [list2SelectedFun 添加线路方法]
             * @return {[type]} [description]
             */
            $scope.list2SelectedFun = function() {
                if ($scope.data.selectedArray.length > 0) {
                    filtrateData();
                } else {
                    for (var i = 0; i < $scope.data.tempSelectedArray.length; i++) {
                        $scope.data.selectedArray.push($scope.data.tempSelectedArray[i]);
                    }
                }
                if ($scope.status.noSelected) $scope.status.noSelected = false;
                $scope.data.tempSelectedArray = [];
            };

            /**
             * [filtrateData 过滤已存在的数据]
             * @return {[type]} [description]
             */
            function filtrateData() {
                var ids = angular.copy($scope.data.tempSelectedArray);
                for (var i = 0; i < ids.length; i++) {
                    for (var n = 0; n < $scope.data.selectedArray.length; n++) {
                        if (ids[i] && ids[i].ID == $scope.data.selectedArray[n].ID) {
                            ids.splice(i, 1);
                            i = 0;
                        }
                    }
                }
                $scope.data.selectedArray = $scope.data.selectedArray.concat(ids);
            }

            /**
             * [confirm 保存]
             * @return {[type]} [description]
             */
            $scope.confirm = function() {
                $validation.validate($scope.NewCircuitConfig).success(function() {
                    if ($scope.data.selectedArray.length == 0) {
                        $scope.status.noSelected = true;
                        return;
                    }
                    save();
                }).error(function() {
                    if ($scope.data.selectedArray.length == 0) $scope.status.noSelected = true;
                    // modalDialog.alertType('请注意检查表单', '', 'info', false, function(){}, function(){})
                });
            };

            /**
             * [save 保存方法]
             * @return {[type]} [description]
             */
            function save() {
                var params = {
                    serviceid: 'mlf_xinhuashe',
                    methodname: 'saveXHSLineAuthor',
                    ObjectId: $scope.status.isNew ? 0 : curItem.XHSLINEAUTHORID,
                    authorName: $scope.status.authorName,
                    lineNames: trsspliceString.spliceString($scope.data.selectedArray, 'LINENAME', ','),
                    lineIds: trsspliceString.spliceString($scope.data.selectedArray, 'ID', ','),
                    authorStatus: $scope.status.authorStatus.toString(),
                    authorTenantId: $scope.status.TenantConfig ? $state.params.tenantid : 0,
                };
                params.startTime = $filter('date')($scope.status.STARTTIME, 'yyyy-MM-dd');
                params.endTime = $filter('date')($scope.status.ENDTIME, 'yyyy-MM-dd');
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    if (typeof(Number(JSON.parse(data))) === 'number') {
                        modalDialog.alertType($scope.status.isNew ? '添加成功' : '修改成功', '', 'success', false, function() {
                            $modalInstance.close('success');
                        });
                    } else {
                        modalDialog.alertType($scope.status.isNew ? '添加失败' : '修改失败', '', 'error', false, function() {}, function() {});
                    }
                });
            }

            /**
             * [cancel 关闭 ]
             * @return {[type]} [description]
             */
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };
        }
    ]);